import type { ReactNode } from "react";
import classNames from "classnames";
import { merge } from "lodash";
import { ClearButtonWrapper } from "@circle-react/components/shared/MemberFilters/DynamicFilters/ClearButtonWrapper";
import { DynamicFilterContext } from "@circle-react/components/shared/MemberFilters/DynamicFilters/DynamicFilterContext";
import { DynamicFilterItems } from "@circle-react/components/shared/MemberFilters/DynamicFilters/DynamicFilterItemsV2";
import { useDynamicFilters } from "@circle-react/components/shared/MemberFilters/DynamicFilters/useDynamicFilters";
import type {
  BaseFilter,
  ProfileFieldBaseFilter,
  RenderFilter,
  RenderProfileFieldFilter,
} from "@circle-react/components/shared/MemberFilters/types";

interface DynamicFiltersProps {
  children: ReactNode;
  className?: string;
  defaultFilterNames?: string[];
  platformFilters: RenderFilter[];
  profileFieldFilters?: RenderProfileFieldFilter[];
  showBackground?: boolean;
  stateFilters: Array<BaseFilter | ProfileFieldBaseFilter>;
}

const DynamicFilterWrapper = ({
  defaultFilterNames = [],
  stateFilters,
  className,
  children,
  platformFilters,
  profileFieldFilters = [],
  showBackground = true,
}: DynamicFiltersProps) => {
  const dynamicFilterProps = useDynamicFilters({
    defaultFilterNames,
  });

  const dynamicFilterContextValue = {
    ...dynamicFilterProps,
    displayedFilters: merge(dynamicFilterProps.displayedFilters, stateFilters),
    platformFilters,
    profileFieldFilters,
  };

  return (
    <DynamicFilterContext.Provider value={dynamicFilterContextValue}>
      <div
        className={classNames(
          "flex w-full items-center justify-between gap-x-1 overflow-x-scroll rounded-b-md px-6 py-3",
          showBackground && "bg-primary",
          className,
        )}
      >
        {children}
      </div>
    </DynamicFilterContext.Provider>
  );
};

export const DynamicFilters = Object.assign(DynamicFilterWrapper, {
  Panel: DynamicFilterItems,
  ClearButton: ClearButtonWrapper,
});
